import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

function Team() {
    const [teamMembers, setTeamMembers] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) {
            navigate("/"); // kicka ut om inte inloggad
        }
    }, [navigate]);

    useEffect(() => {
        const token = localStorage.getItem("token");
        if (!token) return; // redan omdirigerad ovan

        const controller = new AbortController();

        (async () => {
            try {
                const res = await fetch("/api/users", {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    signal: controller.signal,
                });
                const data = await res.json();
                if (res.ok) {
                    setTeamMembers(data);
                } else {
                    console.error("Failed to fetch team members:", data);
                }
            } catch (error) {
                if (error.name === "AbortError") {
                    console.log("Fetch aborted");
                } else {
                    console.error("Error fetching team members:", error);
                }
            }
        })();

        return () => {
            controller.abort();
        };
    }, [navigate]);

    return (
        <div className="p-8">
            <h1 className="text-3xl font-bold mb-8">Team Members</h1>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
                {teamMembers.map((member) => (
                    <Link key={member.id} to={`/users/${member.id}`} className="block">
                        <div className="bg-white rounded-lg shadow-md p-3 flex flex-col items-center hover:shadow-lg transition h-48">
                            {member.profile_pic ? (
                                <img
                                    src={`/assets/profile-pic/${member.profile_pic}`}
                                    alt={member.name}
                                    className="w-16 h-16 rounded-full object-cover mb-2 border-2 border-gray-300"
                                    onError={e => { e.currentTarget.onerror = null; e.currentTarget.style.display = 'none'; }}
                                />
                            ) : (
                                <div className="w-16 h-16 rounded-full bg-gray-300 flex items-center justify-center text-2xl font-bold mb-2">
                                    {member.name ? member.name[0].toUpperCase() : '?'}
                                </div>
                            )}
                            <div className="text-sm font-semibold mb-1 text-center flex-grow flex items-center">{member.name}</div>
                            <div className="text-xs text-gray-500 mb-2 text-center line-clamp-2">{member.email}</div>
                            {member.admin && (
                                <span className="inline-block bg-yellow-400 text-yellow-900 text-xs font-bold px-2 py-1 rounded mt-auto">Admin</span>
                            )}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default Team;